import React, { ReactNode } from "react";
import HeaderComp from "@/components/mentoratComp/HeaderComponent/HeaderComp";


interface MentoratPageProps {
  children: ReactNode;
}

const MentoratPage: React.FC<MentoratPageProps> = ({children}) => {


  return (
    <div>
      <HeaderComp />
      {children}
    </div>
  );
};

export default MentoratPage;
